export const API = process.env['REACT_APP_BASEURL']
export const AUTH = process.env['REACT_APP_AUTH_API_HOST']
